// extracted by mini-css-extract-plugin
export default {"filter":"filter___bjXi7","bucket":"bucket___kvcG5","title":"title___pqeEF"};